import { IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class AgentPolicyDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.AgentPolicyItem, Model.Bookings.Logic.ViewModels.AgentPolicyItem, AgentPolicyItem> {
	protected map(entity: Model.Bookings.Logic.ViewModels.AgentPolicyItem): AgentPolicyItem {
		return new AgentPolicyItemModel(entity);
	}

	private id = -1;
	static make(ctx?: any): AgentPolicyDataService {
		return new AgentPolicyDataService(ctx, ctx => ctx.AgentPolicies, false);
	}

	add(agent: AgentItem): Promise<AgentPolicyItem> {
		const entity = new Model.Bookings.Logic.ViewModels.AgentPolicyItem();
		if (agent.id > 0) {
			entity.agentId = agent.id;
		} else {
			entity.agent = agent.entity;
		}
		entity.id = this.id--;
		entity.priority = this.items.length;

		return this.create(() => entity);
	}
}

export class AgentPolicyItemModel extends EntityModel<Model.Bookings.Logic.ViewModels.AgentPolicyItem, AgentPolicyItem> implements AgentPolicyItem {
	@property<AgentPolicyItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<AgentPolicyItemModel>(o => o.entity.priority, (o, value) => o.entity.priority = value)
	public priority: number;

	@property<AgentPolicyItemModel>(o => o.entity.agentId, (o, value) => o.entity.agentId = value)
	public agentId: number;

	@property<AgentPolicyItemModel>(o => o.entity.policyId, (o, value) => o.entity.policyId = value)
	@IsDefined({ message: 'Policy is required' })
	public policyId: number;

	@property<AgentPolicyItemModel>(o => o.entity.policyName, (o, value) => o.entity.policyName = value)
	@IsDefined({ message: 'PolicyName is required' })
	public policyName: string;
}



// WEBPACK FOOTER //
// ./src/app/bookings/agent-policies/agent-policy-form.data.ts